var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSucessful(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_11065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5 64C40.9869 64 49.1263 60.6286 55.1274 54.6274C61.1286 48.6263 64.5 40.4869 64.5 32C64.5 23.5131 61.1286 15.3737 55.1274 9.37258C49.1263 3.37142 40.9869 0 32.5 0C24.0131 0 15.8737 3.37142 9.87258 9.37258C3.87142 15.3737 0.5 23.5131 0.5 32C0.5 40.4869 3.87142 48.6263 9.87258 54.6274C15.8737 60.6286 24.0131 64 32.5 64ZM27.7 46.4C27.7 45.127 28.2057 43.9061 29.1059 43.0059C30.0061 42.1057 31.227 41.6 32.5 41.6C33.773 41.6 34.9939 42.1057 35.8941 43.0059C36.7943 43.9061 37.3 45.127 37.3 46.4C37.3 47.673 36.7943 48.8939 35.8941 49.7941C34.9939 50.6943 33.773 51.2 32.5 51.2C31.227 51.2 30.0061 50.6943 29.1059 49.7941C28.2057 48.8939 27.7 47.673 27.7 46.4ZM29.3512 15.424C29.4848 14.6862 29.8732 14.0187 30.4487 13.5381C31.0242 13.0574 31.7502 12.7941 32.5 12.7941C33.2498 12.7941 33.9758 13.0574 34.5513 13.5381C35.1268 14.0187 35.5152 14.6862 35.6488 15.424L35.7 16V32L35.6488 32.576C35.5152 33.3138 35.1268 33.9813 34.5513 34.4619C33.9758 34.9426 33.2498 35.2059 32.5 35.2059C31.7502 35.2059 31.0242 34.9426 30.4487 34.4619C29.8732 33.9813 29.4848 33.3138 29.3512 32.576L29.3 32V16L29.3512 15.424Z",
    fill: "#32BA7C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 31.5,
    r: 24.5,
    fill: "#32BA7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1667 21L27 41.1667L17.8334 32",
    stroke: "white",
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_11065"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucessful);
export default __webpack_public_path__ + "static/media/sucessful.6afbd1b008db2f716ce7795deb84a80a.svg";
export { ForwardRef as ReactComponent };